<script>
// import PageEditor from './PageEditor/PageEditor';

export default {
  props: ['item'],
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <div>

    <div class="row">
      <div class="col-sm-12">
        <w-field SimpleDataType="String" v-model="item.title" Title="Title :" Required></w-field>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label for="">Description :</label>
          <CkRichEditor class="small" v-model="item.description"></CkRichEditor>
        </div>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" Title="Live :" v-model="item.status" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="Money" v-model="item.price" Title="Price :" Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" Title="Additional service :" v-model="item.additional" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" v-tippy content="Service is available for purchase without a package." Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" Title="Purchase once :" v-model="item.once" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" v-tippy content="Can this service only be purchased once?" Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" Title="Initial service :" v-model="item.initial" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" v-tippy content="Service available for purchase on the initial listing process?" Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" Title="Upgrade service :" v-model="item.upgrade" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" v-tippy content="Service available as an upgrade?" Required></w-field>
      </div>






      <div class="col-sm-12">
        <label>Upcharges by zip code :</label>
        <div v-for="(zip, zip_i) in item.upcharges" :key="'z'+zip_i" class="input-group mb-1">
          <input type="number" min="9999" max="100000" class="form-control" placeholder="Zip code..." v-model="zip.zip_code" required>
          <div class="input-group-append">
            <w-money class="form-control" v-model="zip.upcharge" placeholder="Upcharge..."  required></w-money>
            <button class="btn btn-white" type="button" v-tippy content="Delete" @click="item.upcharges.splice(zip_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
          </div>
        </div>
        <div class="mb-2">
          <button class="btn btn-sm btn-primary" type="button" @click="item.upcharges.push({zip_code:'',upcharge:0,active:1})"><Icon icon="ri:add-line" height="18"></Icon> Add upcharge</button>
        </div>
      </div>
    </div>

  </div>
</template>
